<template>
  <table class="pb-table">
    <colgroup>
      <col
        v-for="(column, index) in columns"
        :key="index"
        :width="column.width || '*'"
      />
    </colgroup>
    <tr class="th-row">
      <th
        v-for="(column, index) in columns"
        :key="index"
        :data-ariacolumn="index"
        :align="column.align || 'center'"
      >
        <slot :name="`HEAD-${column.key}`">
          {{ column.title }}
        </slot>
      </th>
    </tr>
    <tr v-for="(item, index) in items" :key="index">
      <td
        v-for="(column, key) in columns"
        :key="key"
        :data-ariacolumn="key"
        :align="column.align || 'center'"
        @click="ev => rowClickHandler({ ev, item, index, column, key })"
      >
        <slot :name="column.key" :index="index" v-bind="item">
          {{ item[column.key] || emptyText || "" }}
        </slot>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: "PbTable",
  props: {
    columns: Array, // [{ key: "" }]
    items: Array,
    emptyText: String
  },
  methods: {
    rowClickHandler({ ev, item, index, column }) {
      if (column.clickabled !== false) {
        this.$emit("rowAction", ev, item, index);
      }
    }
  }
};
</script>
<style lang="scss">
.pb-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border-bottom: 1px solid #ccc;
  }

  th {
    font-size: 1.4rem;
    padding: 1.86rem 1.2rem;
  }

  tr:not(.th-row):hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }

  td {
    font-size: 1.35rem;
    height: 48px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    border-bottom: 1px solid #ccc;
  }
}
</style>
